import FormInputComponentCol from './FormInputComponentCol'

export default FormInputComponentCol
